define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"./_Plugin"
], function(declare,Button,_Plugin) {

	return declare([Button, _Plugin], {
		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			// summary: only enable if in Select mode
			return this.inherited(arguments) && this.editor.isDefaultCanvasMode();
		}
	});
});